<template>
  <div style="height:480px;width:480px;">
    <Aliplayer
      v-if="currentPlayerObj.link_addr != ''"
      :vid="currentPlayerObj.link_addr"
      ref="player"
      :needLogin="false"
      style="min-heigth: 300px;height:100%;padding: 0"
    ></Aliplayer>
  </div>
</template>

<script>
import Aliplayer from "@/components/Player/Aliplayer";
export default {
  components: {
    Aliplayer
  },
  data() {
    return {
      currentPlayerObj: {
        link_addr: ""
      }
    };
  },
  mounted() {
    document.getElementsByClassName("nav-box")[0].style.display = "none";
    if(this.$route.params.vid){
        this.currentPlayerObj.link_addr = this.$route.params.vid;
    } 
  },
  methods: {}
};
</script>

<style scoped>
</style>